import API from './'

const action = {

	/**
	 * Get a list of actions.
	 */
	list(params={}, config={})
	{
		let url = API.getUrl(`actions`)

		return API.client().get(url, { params, ...config })
	},

	/**
	 * Get one action details.
	 */
	one(id, params={}, config={})
	{
		let url = API.getUrl(`action/${id}`)

		return API.client().get(url, { params, ...config })
	},

	complete(id, data={})
	{
		let url = API.getUrl(`action/${id}/complete`)

		return API.client().post(url, data)
	}

}

export default action